import React, { useMemo } from "react";
import { useSelector, useStore } from "react-redux";
import { WebMapServiceImageryProvider } from "cesium";
import { ImageryLayer } from "resium";

function RiskLayer() {
  const { select } = useStore();
  const risk = useSelector(select.layer.selectRisk);
  const provider = useMemo(
    () =>
      new WebMapServiceImageryProvider({
        url: risk?.url || "",
        layers: risk?.name || "",
        parameters: {
          service: "WMS",
          format: "image/png",
          transparent: true,
        },
      }),
    [risk]
  );
  if (!risk) return null;

  return <ImageryLayer imageryProvider={provider} show={true} />;
}

export default RiskLayer;
